import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { FilterTypes } from '../../../constants';
import * as D from '../../../deps';
import { type KeysFilterTypes } from '../../../types';
import RecommendedPodcastsAndStations from '../RecommendedPodcastsAndStations/RecommendedPodcastsAndStations';

import './MyMusicEmptyState.scss';

const EmptyFilterHeader = {
  [FilterTypes.ALL]: null,
  [FilterTypes.SONGS]: <FormattedMessage {...D.messages.emptyFilterHeaderSongs} />,
  [FilterTypes.ALBUMS]: <FormattedMessage {...D.messages.emptyFilterHeaderAlbums} />,
  [FilterTypes.ARTISTS]: <FormattedMessage {...D.messages.emptyFilterHeaderArtists} />,
  [FilterTypes.STATIONS]: <FormattedMessage {...D.messages.emptyFilterHeaderStations} />,
  [FilterTypes.PLAYLISTS]: <FormattedMessage {...D.messages.emptyFilterHeaderPlaylists} />,
  [FilterTypes.PODCASTS]: <FormattedMessage {...D.messages.emptyFilterHeaderPodcasts} />,
  [FilterTypes.EPISODES]: <FormattedMessage {...D.messages.emptyFilterHeaderEpisodes} />,
};

interface IMyMusicEmptyState {
  createPlaylist?: $TSFixMeFunction;
  filter?: KeysFilterTypes;
  isPremium?: boolean;
}

export class MyMusicEmptyState extends React.Component<IMyMusicEmptyState> {
  onCreatePlaylistClicked = (): $TSFixMe => {
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.createPlaylist({});
  };

  renderEmptyFilterHeader = (): $TSFixMe => {
    if (this.props.filter === FilterTypes.ALL) {
      if (this.props.isPremium) {
        return <FormattedMessage {...D.messages.emptyFilterHeaderAllT3} />;
      }
      return <FormattedMessage {...D.messages.emptyFilterHeaderAll} />;
    }
    // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    return EmptyFilterHeader[this.props.filter];
  };

  renderEmptyFilterRecommendations = (): $TSFixMe => {
    if (this.props.filter === FilterTypes.ALL) {
      // @ts-expect-error TS(2739) FIXME: Type '{}' is missing the following properties from... Remove this comment to see the full error message
      return <RecommendedPodcastsAndStations />;
    } else if (this.props.filter === FilterTypes.STATIONS) {
      return <D.AsyncDomain domain='playback' component='StationsYouMightLike' isMyMusic={true} />;
    }
    return null;
  };

  renderCtaButton = (): $TSFixMe => {
    // @ts-expect-error TS(2551) FIXME: Property 'STATION' does not exist on type '{ reado... Remove this comment to see the full error message
    if ([FilterTypes.ALL, FilterTypes.STATION].includes(this.props.filter)) {
      return <D.BrowseCta />;
    } else if (this.props.filter === FilterTypes.PLAYLISTS) {
      return (
        <D.ButtonT3
          size={D.ButtonT3Size.LARGE}
          onClick={this.onCreatePlaylistClicked}
          qaTag={D.QA.MCNPB}
        >
          <FormattedMessage {...D.messages.createPlaylist} />
        </D.ButtonT3>
      );
    }
    return null;
  };

  render(): $TSFixMe {
    return (
      <div className='MyMusicEmptyState' data-qa={D.QA.MCEMPTY}>
        <div className='MyMusicEmptyState__header'>{this.renderEmptyFilterHeader()}</div>
        <div className='MyMusicEmptyState__recommendations'>
          {this.renderEmptyFilterRecommendations()}
        </div>
        <div className='MyMusicEmptyState__ctaButton'>{this.renderCtaButton()}</div>
      </div>
    );
  }
}

// eslint-disable-next-line react-redux/mapDispatchToProps-returns-object
export const mapDispatchToProps: $TSFixMe = (dispatch: $TSFixMe) => {
  return bindActionCreators({ createPlaylist: D.createPlaylist }, dispatch);
};

export default connect(null, mapDispatchToProps)(MyMusicEmptyState);
